module.exports = __webpack_public_path__ + "templates/authentication.html";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=templates/[name].[ext]!./src/app/public/authentication/authentication.html
// module id = 305
// module chunks = 15